class Env {
	
}
Env.isLizenzManager = false;
Env.isLizenzPackageManager = false;
export default Env;